<template>
  <v-app style="background:transparent">
    <v-img src="@/AsEmblem300.png" width="250px" style="text-align:justify;margin:auto;max-width:300px;margin-top:20px"/>
    <div style="text-align:justify;margin:auto;padding:5%;max-width:800px;margin-top:0px;padding-top:0px">
        <v-row
          align="center"
          justify="center"
        >
      <v-card-text style="color:rgb(20,20,20);font-weight:650">
      <h1 style="text-align:center !important;color:rgb(20,20,20)">a hive of hope</h1><br/>
        For in hope we were saved. Now hope that is seen is not hope, because who hopes for what he sees? - Rom 8:24
        <br/><br/>
        Always be prepared to give an answer to everyone who asks you to give the reason for the hope that you have. - 1 Peter 3:15
        <br/><br/>
        Brothers and sisters, stop thinking like children. In regard to evil be infants, but in your thinking be adults. - 1 Cor 14:20
        <br/><br/>
        And bees came up from the cells of the comb, and they were white as snow, and their wings were irridescent - purple and blue and gold - and they had golden diadems on their heads and sharp-pointed stings. - JosAs 16:13
        <br/><br/>
        Besides, it is written that the tree shall be known by its fruits. The Church has borne too many evil fruits for there not to have been some mistake at the beginning. Europe has been spiritually uprooted, cut off from that antiquity in which all the elements of our civilization have their origin; and she has gone about uprooting the other continents from the sixteenth century onwards. Missionary zeal has not Christianized Africa, Asia and Oceania, but has brought these territories under the cold, cruel and destructive domination of the white race, which has trodden down everything. It would be strange, indeed, that the word of Christ should have produced such results if it had been properly understood. - Simone Weil
      </v-card-text>
        </v-row>
    </div>

  </v-app>
</template>

<script>
export default {
  name: "SignUp",
};
</script>

<style scoped>
.v-card__text, .v-card__title {
  word-break: normal !important;
}
.libCard {
  margin:auto;
  margin-top:10px;
  margin-bottom:10px;
  background-color:rgb(5,5,5,0.7);
  max-width:700px;
}
.libTitle {
  font-size: 1.4em;
  line-height: 1em;
  color: #fdfdfd;
}
</style>
